/* eslint-disable @typescript-eslint/no-var-requires */
const theme = require('~/theme/craco');
const branding = require('~/branding');

const constants = {
  ...theme,
  ...branding,
};

export default constants;
